import { createDemoPeriodComparisonMatcher } from '@web/lib/demo/utils';
import { getInterval, getPreviousPeriod, groupByPeriod } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockCurrentPeriodData = [
    { docsSharedExternally: 5, previousPeriod: 8, teamAverage: 4 },
    { docsSharedExternally: 3, previousPeriod: 6, teamAverage: 5 },
    { docsSharedExternally: 8, previousPeriod: 4, teamAverage: 6 },
    { docsSharedExternally: 2, previousPeriod: 9, teamAverage: 3 },
    { docsSharedExternally: 10, previousPeriod: 7, teamAverage: 7 },
    { docsSharedExternally: 4, previousPeriod: 3, teamAverage: 5 },
    { docsSharedExternally: 6, previousPeriod: 11, teamAverage: 4 }
];
export var docsSharedExternally = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var dateFrom = startOfDay(input.dateFrom);
    var dateTo = endOfDay(input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periodsData = groupByPeriod([], dateFrom, dateTo, interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodMatcher = createDemoPeriodComparisonMatcher(input, interval, periodsData, previousPeriods);
    var periods = periodsData.map(function (period, idx) {
        var _a;
        var mockData = mockCurrentPeriodData[idx % mockCurrentPeriodData.length];
        var prevPeriod = periodMatcher.getItem(idx, previousPeriods);
        return {
            period: period.date,
            previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '',
            docsSharedExternally: mockData.docsSharedExternally,
            previousPeriod: mockData.previousPeriod,
            teamAverage: input.userId ? mockData.teamAverage : 0
        };
    });
    var totals = periods.reduce(function (acc, period) { return ({
        docsSharedExternally: acc.docsSharedExternally + period.docsSharedExternally,
        previousPeriod: acc.previousPeriod + period.previousPeriod,
        teamAverage: acc.teamAverage + period.teamAverage
    }); }, { docsSharedExternally: 0, previousPeriod: 0, teamAverage: 0 });
    return { totals: totals, periods: periods };
};
